<template>
  <vx-card title="Bestseller">
    <vs-table :data="bestSellers" noDataText="Keine Daten vorhanden">
      <template slot="thead">
        <vs-th>#</vs-th>
        <vs-th>Produkt</vs-th>
        <vs-th>Menge</vs-th>
        <vs-th>Bestellungen</vs-th>
      </template>
      <template slot-scope="{ data }">
        <vs-tr :key="index" v-for="(tr, index) in data">
          <vs-td>{{ index + 1 }}</vs-td>
          <vs-td>{{ tr.name }}</vs-td>
          <vs-td>{{ tr.totalQty }}</vs-td>
          <vs-td>{{ tr.orderCount }}</vs-td>
        </vs-tr>
      </template>
    </vs-table>
  </vx-card>
</template>

<script>
export default {
  name: "AnalyticsBestSellers",
  computed: {
    bestSellers() {
      const perf = this.$store.state.analytics.productPerformance;
      return perf ? perf.bestSellers : [];
    },
  },
};
</script>
